import React from 'react';
import styles from './SummaryCards.module.css';

/**
 * SummaryCards - 이벤트 지급내역/사용내역 상단 KPI 카드
 * @param {{ items: Array<{ label: string, value: string }> }} props
 */
const SummaryCards = ({ items = [] }) => {
  return (
    <div className={styles.summaryRow}>
      {items.map((item, i) => (
        <div key={i} className={styles.summaryCard}>
          <div className={styles.summaryLabel}>{item.label}</div>
          <div className={styles.summaryValue}>{item.value}</div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;
